import React from 'react';
import { PictoProps } from './index';

export const CirclePlay = (props: PictoProps) => (
  <svg
    width={props.width || '28'}
    height={props.height || '28'}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.5625 14C27.5625 21.4904 21.4904 27.5625 14 27.5625C6.50964 27.5625 0.4375 21.4904 0.4375 14C0.4375 6.50964 6.50964 0.4375 14 0.4375C21.4904 0.4375 27.5625 6.50964 27.5625 14Z"
      stroke="white"
      strokeWidth="0.875"
    />
    <path
      d="M18.8125 14.1717L10.9375 18.7183V9.625L18.8125 14.1717Z"
      stroke="white"
      strokeWidth="0.875"
      strokeLinejoin="round"
    />
  </svg>
);
